import React, { useEffect, useState } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import ClearViewPage from '../ClearViewPage';
import { fetchTeacherStudentDetail } from '../../services/api';

// Lets a teacher preview a student's progress exactly as the family would see it,
// including any leadership-controlled percentage/red-status simplifications.
export default function TeacherParentPreview() {
  const { studentId, classId } = useParams();
  const location = useLocation();
  const stateStudent = location.state?.student;
  const initialName = stateStudent
    ? `${stateStudent.first_name || ''} ${stateStudent.last_name || ''}`.trim()
    : '';

  const [studentName, setStudentName] = useState(initialName);

  useEffect(() => {
    if (initialName || !studentId) return;

    let mounted = true;
    fetchTeacherStudentDetail(studentId)
      .then((data) => {
        if (!mounted || !data?.student) return;
        const name = `${data.student.first_name || ''} ${data.student.last_name || ''}`.trim();
        if (name) setStudentName(name);
      })
      .catch(() => {
        // silently ignore; fallback will remain to Child #ID
      });

    return () => {
      mounted = false;
    };
  }, [initialName, studentId]);

  return (
    <ClearViewPage
      studentId={studentId}
      classId={classId}
      studentName={studentName}
      role="teacher"
      previewAsFamily
    />
  );
}
